import React, { useContext } from "react";
import { store } from "../components/Store";
import { Img } from "../components/shared/img";
import { Link, useHistory } from "react-router-dom";
import { Book } from "../components/shared/book";
import { ASSETS_URL } from "../components/Store";
import useObtenerTraducciones from "../js/translations/useObtenerTraducciones";
import { Icon } from "@iconify/react";
import { useFavoritesManager } from "../hooks/use-favorites-manager";
import { usePagination } from "../hooks/usePagination";
import { useQueryParams } from "../hooks/useQueryParams";
import { PaginationControls } from "../components/shared/pagination-controls";
import { usePersonalAccountInstitutionsManager } from "../hooks/use-user-institutions";

/**
 * Este componente renderiza la pantalla con la lista de libros favoritos
 */
export const Favoritos = () => {
	const history = useHistory();
	const globalState = useContext(store);
	const favoritesManager = useFavoritesManager();
	const favorites = favoritesManager.favoriteBooks;
	// const favorites = globalState?.state?.userBooksData?.books; // PARA PRUEBAS.
	const isIndividualUser =
		globalState?.state?.cantidadLibros < 40 && globalState?.state?.cantidadLibros >= 0;
	const params = useQueryParams();
	const defaultPage = params?.get("page")? Number(params?.get("page")) : 1;
	const pagination = usePagination({
		itemsPerPage: 16,
		defaultPage,
		data: favorites,
		onChangePage: (page) => {
			scrollToTop()
			history.replace({ pathname: "/favoritos", search: `?page=${page}` });
		},
	});

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "instant",
		});
	};

	const currentPageData = pagination?.currentPageData;
	const isPersonalAccount = globalState?.state?.isPersonalAccount;
	const institutionsManager = usePersonalAccountInstitutionsManager();
	const currentInstitution = institutionsManager?.current;
	const currentInstitutionName = currentInstitution?.name;


	//Hooks personalizados
	const { textosSeccion: textosInterfaz } = useObtenerTraducciones("favoritos");

	return (
		<div className="focusable-secondary main-container">
			<div className="py-5">
				<div className="surface--bg main-content-3 p-3 px-lg-4">
					<h2
						tabIndex={0}
						className="descargados-title"
					>
						{textosInterfaz?.titulo || "Tus favoritos"}
					</h2>
					{
						isPersonalAccount && 
					<p className="blue-dark--color text-18">{textosInterfaz?.descripcion || "Acá verás tus libros favoritos de"} <strong>{currentInstitutionName}</strong></p>
					}

					{favorites.length === 0 ? (
						<div>
							<Img
								style={{ maxWidth: "300px" }}
								alt="Blop sin favoritos"
								className="mx-auto mt-3"
								src={"/img/favoritos.png"}
							/>
							<div className="text-center mt-3 onprimary--color">
								<h3 className="title4">
									{textosInterfaz?.subtitulo || "Aún no tienes libros favoritos"}
								</h3>
								{!isPersonalAccount && (
									<p className="title5">
										{textosInterfaz?.recuerda ||
											"Recuerda que los libros solo quedan guardados en tu navegador"}
									</p>
								)}
								<Link to={"/busqueda?sch="} className="btn btn-primary mt-4">
									{textosInterfaz?.buscar || "Buscar libros"}
								</Link>
							</div>
						</div>
					) : (
						<>
							{!isPersonalAccount && (
								<p className="text-22 text-center">
									{textosInterfaz?.recuerda ||
										"Recuerda que los libros solo quedan guardados en tu navegador"}
								</p>
							)}
							<div
								style={{ overflow: "visible" }}
								className="row px-0 justify-content-start  favorite mt-5"
							>
								{currentPageData.map((item, index) => {
									return (
										<div
											className={`cover-book favorite-col-book`}
											key={`book-${item?.idLibro || index}`}
										>
											<div className="d-flex justify-content-center">
											<Book
												libro={{
													...item,
													portada: `${ASSETS_URL}${item?.portada}`,
													title:
														item.nombreLibro ||
														item?.titulo ||
														item?.title ||
														item?.nombre ||
														"N/A",
												}}
												alSeleccionar={() =>
													isIndividualUser
														? history.push(`/visor/${item?.idLibro}`)
														: history.push(item?.webUrl)
												}
												ocultarOpciones={{
													checkbox: true,
													bookType: false,
													botonFavoritos: false,
												}}
												alAgregarFav={(item) =>
													favoritesManager.add({ bookId: item?.idLibro })
												}
												alRemoverFav={(item) =>
													favoritesManager.remove({
														bookId: item?.idLibro,
													})
												}
												estadoInicial={{
													esFavorito: favorites.some(
														(fav) => fav?.idLibro === item?.idLibro
													),
												}}
											/>
											</div>
										</div>
									);
								})}

								{pagination.hasMore && (
									<div
										className="w-100 d-flex flex-column justify-content-center align-items-center"
										onClick={() => pagination.nextPage()}
									>
										<p className="secondary-inverse--color bold">
											{`${
												textosInterfaz?.scroll ||
												" Desplazate hacia abajo para cargar más libros."
											}`}
										</p>
										<Icon
											icon="mdi:mouse-move-down"
											className="secondary-inverse--color text-28 mx-2"
											width={30}
										/>
									</div>
								)}
							</div>
						</>
					)}
					{
						favorites.length > 0 && pagination.totalPages > 1 && (
							<PaginationControls
								onClickNext={() => pagination.nextPage()}
								onClickPrev={() => pagination.prevPage()}
								onClickPage={(page) => pagination.goToPage(page)}
								currentPage={pagination.currentPage}
								totalPages={pagination.totalPages}
								range={pagination.range}
							/>
						)
					}
				</div>
			</div>
		</div>
	);
};
